// axios-multipart.js
import Axios from "axios";
import config from "../config/config";
import { getToken } from "./cookie";

const axiosMultipart = Axios.create({
  baseURL: config.api.URL,
  headers: {
    "Cache-control": "no-cache, no-store",
    Pragma: "no-cache",
  },
});

axiosMultipart.interceptors.request.use((config) => {
  if (getToken()) {
    config.headers.Authorization = `Bearer ${getToken()}`;
  }
  return config;
});

export const POST_MULTIPART = async (url, formData) => {
  const res = await axiosMultipart.post(url, formData);
  return res?.data;
};
